import ReservationBuilderDispatcher from '../dispatcher/ReservationBuilderDispatcher'
import ReservationBuilderConstants from '../constants/ReservationBuilderConstants'

var ReservationBuilderActions = {
  /**
  * Initialize the ReservationBuilderStore
  *
  * @param {object} opts
  */
  init: function (opts) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.INIT,
      opts: opts
    });
  },

  addCard: function (card) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.ADD_CARD,
      card: card
    });
  },


  addReservationSegment: function (room_type, check_in_date, check_out_date, rate, quantity) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.ADD_RESERVATION_SEGMENT,
      room_type: room_type,
      check_in_date: check_in_date,
      check_out_date: check_out_date,
      rate: rate,
      quantity: quantity,
    });
  },

  applyGroupContract: function (group_contract) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.APPLY_GROUP_CONTRACT,
      group_contract: group_contract,
    });
  },

  changeTypeOfBooking: function (type_of_booking) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_TYPE_OF_BOOKING,
      type_of_booking: type_of_booking,
    })
  },


  calculatePricing: function () {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CALCULATE_PRICING,
    })
  },

  cardElementKeyIncremented: function () {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CARD_ELEMENT_KEY_INCREMENTED,
    })
  },
  changeAddOns(add_ons) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_ADD_ONS,
      add_ons: add_ons,
    });
  },

  changeAddOnsReservationSegmentId(add_ons_reservation_segment_id) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_ADD_ONS_RESERVATION_SEGMENT_ID,
      add_ons_reservation_segment_id: add_ons_reservation_segment_id,
    });
  },

  changeCardInput: (card) => {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_CARD_INPUT,
      card: card
    });
  },

  voucherAdded: (voucher) => {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.ADD_VOUCHER,
      voucher: voucher
    });
  },

  changeBookingPaymentAmount: (amount, id) => {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_BOOKING_PAYMENT_AMOUNT,
      amount: amount,
      id: id
    });
  },

  resetCardDetails: () => {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.RESET_CARD_DETAILS,
    });
  },

  setCardErrorsToState: (cardErrors) => {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_CARD_ERRORS_TO_STATE,
      cardErrors: cardErrors
    });
  },

  disableCardNameInput: () => {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.DISABLE_CARD_NAME_INPUT,
    });
  },

  changeDates: function (check_in_date, check_out_date) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_DATES,
      check_in_date: check_in_date,
      check_out_date: check_out_date,
    });
  },

  changeGuestTypeCount: function(guest_type_id, number_of_guests) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_GUEST_TYPE_COUNT,
      guest_type_id: guest_type_id,
      number_of_guests: number_of_guests,
    })
  },

  changePromoCode: function (promo_code, refreshAccommodations) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CHANGE_PROMO_CODE,
      promo_code: promo_code,
      refreshAccommodations: refreshAccommodations
    })
  },

  submitPromoCode: function (promo_code) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SUBMIT_PROMO_CODE,
      promo_code: promo_code,
    })
  },

  clearCustomer: function () {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.CLEAR_CUSTOMER
    });
  },

  gotoStep: function (step, direction) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.GOTO_STEP,
      step: step,
      direction: direction
    });
  },

  hideRates: function (accommodation) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.HIDE_RATES,
      accommodation: accommodation,
    });
  },

  jumptoStep: function (step) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.JUMPTO_STEP,
      step: step,
    });
  },

  removeSegment: function (segment_id) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.REMOVE_SEGMENT,
      segment_id: segment_id,
    });
  },

  save: function () {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SAVE
    });
  },

  setBillingPolicy: function (billing_policy) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_BILLING_POLICY,
      billing_policy: billing_policy
    });
  },

  setButtons: function (prev_btn, next_btn) {
    setTimeout(function () {
      ReservationBuilderDispatcher.dispatch({
        action: ReservationBuilderConstants.SET_BUTTONS,
        prev_btn: prev_btn,
        next_btn: next_btn,
      });
    }, 0);
  },

  setCustomer: function (customer, form_field_id) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_CUSTOMER,
      customer: customer,
      selected_rating: customer.selected_rating,
      selected_emoji: customer.selected_emoji,
      selected_r: customer.selected_r,
      selected_e: customer.selected_e,
      form_field_address_field_id: form_field_id,
    });
  },
  
  setEmojiState: function (emoji_answers) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_EMOJI_STATE,
      emoji_answers: emoji_answers,
    });
  },

  setRatingState: function (rating_answers) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_RATING_STATE,
      rating_answers: rating_answers,
    });
  },

  setFormFields: function (fields) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_FORM_FIELDS,
      form_fields: fields,
    });
  },
  setForms: function (forms) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_FORM_FIELDS,
      forms: forms,
    });
  },

  setValue: function (name, value) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.SET_VALUE,
      name: name,
      value: value,
    });
  },

  updateSegment: function (segment, calculatePricing) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.UPDATE_SEGMENT,
      segment: segment,
      calculatePricing: calculatePricing,
    });
  },

  updateSegmentGuestCount: function (segment, guest_type_id, count) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.UPDATE_SEGMENT_GUEST_COUNT,
      segment: segment,
      guest_type_id: guest_type_id,
      count: count,
    });
  },

  viewRates: function (accommodation) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.VIEW_RATES,
      accommodation: accommodation
    });
  },

  setLoading: function (loading) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.LOADING,
      loading: loading
    });
  },

  setDateRangePickerVisibility: function(visible) {
    ReservationBuilderDispatcher.dispatch({
      action: ReservationBuilderConstants.DATE_RANGE_PICKER_VISIBLE,
      visible: visible
    });
  }

};

export default ReservationBuilderActions
